import { IGeneralData } from "@/interfaces";
import { fetcher } from "@/lib";

export interface IOnlineChatMessage {
  id: number;
  sender_type: "user" | "ai" | "admin" | "system";
  message: string;
  page_url?: string | null;
  created_at: string;
}

export interface IOnlineChatSession {
  id: number;
  token: string;
  mobile?: string | null;
  status: string;
  handling_mode?: "ai" | "admin";
  messages: IOnlineChatMessage[];
}

export interface IOnlineChatSettings {
  online_chat_enabled: boolean;
}

export async function getOnlineChatSettings() {
  return fetcher<IGeneralData<IOnlineChatSettings>>({
    url: "/api/chat/settings",
  });
}

export async function createOnlineChatSession({
  mobile,
  token,
  pageUrl,
}: {
  mobile?: string;
  token?: string;
  pageUrl?: string;
}) {
  return fetcher<IGeneralData<IOnlineChatSession>, { mobile?: string; page_url?: string }>({
    url: "/api/chat/sessions",
    method: "POST",
    payload: {
      ...(mobile ? { mobile } : {}),
      ...(pageUrl ? { page_url: pageUrl } : {}),
    },
    token,
  });
}

export async function getOnlineChatSession({
  id,
  sessionToken,
}: {
  id: number;
  sessionToken: string;
}) {
  return fetcher<IGeneralData<IOnlineChatSession>>({
    url: `/api/chat/sessions/${id}`,
    params: {
      token: sessionToken,
    },
  });
}

export async function sendOnlineChatMessage({
  id,
  sessionToken,
  message,
  pageUrl,
}: {
  id: number;
  sessionToken: string;
  message: string;
  pageUrl?: string;
}) {
  return fetcher<
    IGeneralData<{
      user_message: IOnlineChatMessage;
      ai_message: IOnlineChatMessage | null;
      session: IOnlineChatSession;
    }>,
    { token: string; message: string; page_url?: string }
  >({
    url: `/api/chat/sessions/${id}/messages`,
    method: "POST",
    payload: {
      token: sessionToken,
      message,
      ...(pageUrl ? { page_url: pageUrl } : {}),
    },
  });
}
